import React from 'react';

function GoogleWordmark({ className = '' }) {
  return (
    <span className={`tsr-google-wordmark ${className}`.trim()} aria-label="Google">
      <span className="tsr-google-wordmark__g">G</span>
      <span className="tsr-google-wordmark__o1">o</span>
      <span className="tsr-google-wordmark__o2">o</span>
      <span className="tsr-google-wordmark__g2">g</span>
      <span className="tsr-google-wordmark__l">l</span>
      <span className="tsr-google-wordmark__e">e</span>
    </span>
  );
}

export default GoogleWordmark;
